// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rgfHlrDISYrT1hmIwztj {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
}

.fq5FvdcULK3Nccpxjkgr {
    min-width: 0;
    padding: 2.4rem;
}

.hPEduMfYsMN6IbGFYFEO {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));
    gap: 2.4rem;
}

.IN4O6vclN6CblQ8BcuES {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    min-width: 0;
}

.woD_9B03rnSj8Q5HOYAd {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.6rem;
    flex-wrap: wrap;
    margin-bottom: 2.4rem;
}

.s5CN2iQEAtg7pbJNoJyC {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));
    gap: 1.2rem;
    margin-bottom: 2.4rem;
}

.SgHoBWxP2Y2aj4UIXhAJ {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
}

.mzCE1AEXw6tteDmIyWSg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.2rem;
}

.ClR2oHCEVbtZFVMABpDV {
    flex: 1;
    min-width: min(100%, 20rem);
    overflow-wrap: anywhere;
}

.VQMwoyBlmMtad2QGmpfU {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 1.2rem;
}

.TxUAWvTxnGKOI6O7uUog {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
    text-align: center;
}

.YXu76XOFFLELNVFlp5Lf {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
}

.OwvVr3XPsRNF7kIhjHwh {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 18rem), 1fr));
    gap: 1.2rem;
}

.Xb01MKjiTL_tGbFPH1zW {
    display: flex;
    gap: 1.2rem;
    flex-wrap: wrap;
    max-height: 24rem;
    overflow-y: auto;
}

.MixbM_Z_s2ZixU5WSFgl {
    display: flex;
    align-items: center;
    gap: 1.2rem;
}

.MixbM_Z_s2ZixU5WSFgl > :first-child {
    flex: 1;
    min-width: 0;
}

.HMr9l1JoEAJTbpZ6cAng {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
}

._5vngDbdSKNa1iWhqYtp {
    display: inline-flex;
    align-items: center;
    gap: 0.8rem;
    max-width: 100%;
    overflow-wrap: anywhere;
}

.ZkmUGvFgG7M2i_SMP3Bd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.6rem;
    flex-wrap: wrap;
    padding-top: 2.4rem;
    padding-bottom: 0.8rem;
}

@media (max-width: 600px) {
    .fq5FvdcULK3Nccpxjkgr {
        padding: 1.6rem;
    }

    .ZkmUGvFgG7M2i_SMP3Bd .VQMwoyBlmMtad2QGmpfU {
        width: 100%;
    }

    .MixbM_Z_s2ZixU5WSFgl {
        flex-wrap: wrap;
    }

    .MixbM_Z_s2ZixU5WSFgl > :first-child {
        flex-basis: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/pages/Segments/SegmentBuilder/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,OAAO;IACP,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".builder {\n    display: flex;\n    flex-direction: column;\n    gap: 2.4rem;\n}\n\n.panel {\n    min-width: 0;\n    padding: 2.4rem;\n}\n\n.fieldGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));\n    gap: 2.4rem;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    min-width: 0;\n}\n\n.panelHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 1.6rem;\n    flex-wrap: wrap;\n    margin-bottom: 2.4rem;\n}\n\n.matchGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));\n    gap: 1.2rem;\n    margin-bottom: 2.4rem;\n}\n\n.filterList {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n}\n\n.filterCard {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n\n.filterCopy {\n    flex: 1;\n    min-width: min(100%, 20rem);\n    overflow-wrap: anywhere;\n}\n\n.actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n\n.emptyState {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.8rem;\n    text-align: center;\n}\n\n.filterForm {\n    display: flex;\n    flex-direction: column;\n    gap: 2.4rem;\n}\n\n.valuesGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 18rem), 1fr));\n    gap: 1.2rem;\n}\n\n.valueOptions {\n    display: flex;\n    gap: 1.2rem;\n    flex-wrap: wrap;\n    max-height: 24rem;\n    overflow-y: auto;\n}\n\n.valueEntry {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n}\n\n.valueEntry > :first-child {\n    flex: 1;\n    min-width: 0;\n}\n\n.chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n}\n\n.chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.8rem;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n}\n\n.footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.6rem;\n    flex-wrap: wrap;\n    padding-top: 2.4rem;\n    padding-bottom: 0.8rem;\n}\n\n@media (max-width: 600px) {\n    .panel {\n        padding: 1.6rem;\n    }\n\n    .footer .actions {\n        width: 100%;\n    }\n\n    .valueEntry {\n        flex-wrap: wrap;\n    }\n\n    .valueEntry > :first-child {\n        flex-basis: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var builder = `rgfHlrDISYrT1hmIwztj`;
export var panel = `fq5FvdcULK3Nccpxjkgr`;
export var fieldGrid = `hPEduMfYsMN6IbGFYFEO`;
export var field = `IN4O6vclN6CblQ8BcuES`;
export var panelHeader = `woD_9B03rnSj8Q5HOYAd`;
export var matchGrid = `s5CN2iQEAtg7pbJNoJyC`;
export var filterList = `SgHoBWxP2Y2aj4UIXhAJ`;
export var filterCard = `mzCE1AEXw6tteDmIyWSg`;
export var filterCopy = `ClR2oHCEVbtZFVMABpDV`;
export var actions = `VQMwoyBlmMtad2QGmpfU`;
export var emptyState = `TxUAWvTxnGKOI6O7uUog`;
export var filterForm = `YXu76XOFFLELNVFlp5Lf`;
export var valuesGrid = `OwvVr3XPsRNF7kIhjHwh`;
export var valueOptions = `Xb01MKjiTL_tGbFPH1zW`;
export var valueEntry = `MixbM_Z_s2ZixU5WSFgl`;
export var chips = `HMr9l1JoEAJTbpZ6cAng`;
export var chip = `_5vngDbdSKNa1iWhqYtp`;
export var footer = `ZkmUGvFgG7M2i_SMP3Bd`;
export default ___CSS_LOADER_EXPORT___;
